import React, { memo } from 'react';
import styled from "styled-components";

const FakeView = memo(({ className }) => {
  return (
    <div className={className} role="status" aria-busy="true">
      <div className='view-header view-animation view-margin'>
      </div>
      <div className='view-menu view-animation view-margin'>

      </div>
      {
        [1,2,3].map(item => 
          <React.Fragment key={item}>
            <div className='view-title view-animation view-margin'>

            </div>
            <div className='view-item view-animation view-margin'>

            </div>
          </React.Fragment>
          
          )
      }
    </div>
  );
});

export default styled(FakeView)`
   
   .view-header {
      width: 100%;
      height: 150px;
    }
    .view-margin {
      margin-top: 15px;
      margin-bottom: 15px;
      margin-left: 10px;
      margin-right: 10px;
      border-radius: 5px;
    }
    .view-menu {
      width: 100%;
      height: 40px;
    }
    .view-item {
      width: 100%;
      height: 300px;
    }
    .view-title {
      width: 200px;
      height: 20px;
    }
   .view-animation {
      background: linear-gradient(90deg, #ababab, #f1f1f5, #e4e4e6);//#dddfe2;
      background-size: 200% 200%;
      animation: gradient 1.5s linear infinite;        
  }
  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    30% {
      background-position: 100% 50%;
    }
    60% {
      background-position: 60% 50%;
    }
    90% {
      background-position: 30% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;
